export enum UserRoles {
  FieldUser = "fieldUser",
  StandardUser = "standardUser",
  ExpertUser = "expertUser",
  AdminUser = "adminUser",
  SuperAdmin = "superAdmin",
}
